import React from 'react'
import { observer } from 'mobx-react'
import { CheckList, CheckListItem } from 'components/CheckList'

const PrerealtimeChallengeView = ({ challenge }) => (
  <div className="prerealtime-challenge">
    <CheckList>
      {challenge.choices.map((choice) =>
        <CheckListItem
          small
          key={choice.category + choice.value}
          onChange={(checked) => checked && challenge.setAnswer(choice)}
          checked={challenge.selectedChoice === choice}
        >
          {choice.value} ({choice.category})
        </CheckListItem>
      )}
    </CheckList>
  </div>
)

export default observer(PrerealtimeChallengeView)



// WEBPACK FOOTER //
// ./src/client/components/LinkAccountDialog/QuovoProvider/MultiFactorAuth/PrerealtimeChallenge/View.jsx